import { KeyboardEvent, useRef, useState } from 'react';
import { useRachelChatContext } from '../../contexts/Rachel.context';
import { PendingAskUser } from '../../hooks/usePendingAskUser';
import { RACHEL_ASK_USER_SKIPPED_ANSWER } from '../../rachel.consts';
import { RachelAskUserOutput } from '../../rachel.contract';

export const useRachelAskUserCard = ({ toolCallId }: Pick<PendingAskUser, 'toolCallId'>) => {
  const { addAskUserAnswer, isStreaming } = useRachelChatContext();
  const [otherText, setOtherText] = useState('');
  const submittedRef = useRef(false);

  const submit = (output: RachelAskUserOutput) => {
    if (isStreaming || submittedRef.current) {
      return;
    }
    submittedRef.current = true;
    addAskUserAnswer(toolCallId, output);
  };

  const selectOption = (option: string) => submit({ resposta: option });

  const skip = () => submit({ resposta: RACHEL_ASK_USER_SKIPPED_ANSWER });

  const handleOtherKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    const text = otherText.trim();
    if (event.key !== 'Enter' || event.nativeEvent.isComposing || !text) {
      return;
    }
    event.preventDefault();
    submit({ resposta: text });
  };

  return {
    otherText,
    isDisabled: isStreaming,
    setOtherText,
    selectOption,
    skip,
    handleOtherKeyDown,
  };
};
